import React, { useEffect, useRef, useState } from "react";
import LayoutBackOffice from "../../../components/LayoutBackOffice";
// import iconecommande from "../../../assets/IconeSvg/classe.svg";
import iconeCloseWindow from "../../../assets/IconeSvg/close_window.svg";
import iconethreeDots from "../../../assets/IconeSvg/treeDotsGray.svg";
import iconeDelete from "../../../assets/IconeSvg/delete.svg";
import iconePencil from "../../../assets/IconeSvg/pencil.svg";
import iconeAppareilPhoto from "../../../assets/IconeSvg/appareil_photo.svg";

import iconeDownload from "../../../assets/IconeSvg/download-minimalistic.svg";
import { Drawer, Pagination, SwipeableDrawer } from "@mui/material";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

import SnackbarAlert from "../../../components/SnackbarAlert";
import {
  enregistrerCommandes,
  listeDesCommandes,
  modifierCommandesById,
  supprimerCommandesById
} from "../../../services/commandes/CommandesRequest";

import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";
import axios from "axios";

// import { ArrowDownToLine } from "lucide-react";

const Commandes = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 10,
    nombrePage: 1,
    pagePagination: 1
  });

  const [loadingData, setLoadingData] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingDataLocalisation, setLoadingDataLocalisation] = useState(false);

  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);

  const [niveauSelected, setNiveauSelected] = useState("");
  const [commissionSelected, setCommissionSelected] = useState("");
  const [searchParam, setSearchParam] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [listecommande, setlistecommande] = useState([]);
  const [commandeInfo, setcommandeInfo] = useState(null);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentPosition, setCurrentPosition] = useState(null);
  const [modalMapIsOpen, setModalMapIsOpen] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);

  const [commandeData, setCommandeData] = useState({
    client: { nomComplet: '', tel: '' },
    items: [{ product: '', quantity: 1, priceAtOrder: 0 }],
    addressLivraison: '',
    city: '',
    country: '',
    paymentMethod: 'card',
    shippingFee: 0,
  });


  // Si on édite, pré-remplissage
  useEffect(() => {
    if (commandeInfo) {
      setCommandeData({
        client: commandeInfo.client,
        items: commandeInfo.items.map(i => ({
          product: i.product._id,
          quantity: i.quantity,
          priceAtOrder: i.priceAtOrder
        })),
        addressLivraison: commandeInfo.addressLivraison,
        city: commandeInfo.city,
        country: commandeInfo.country,
        paymentMethod: commandeInfo.paymentMethod,
        shippingFee: commandeInfo.shippingFee
      });
    }
  }, [commandeInfo]);

  // Handlers
  const handleClientChange = e =>
    setCommandeData({
      ...commandeData,
      client: { ...commandeData.client, [e.target.name]: e.target.value }
    });

  const handleFieldChange = e =>
    setCommandeData({ ...commandeData, [e.target.name]: e.target.value });

  const handleItemChange = (idx, e) => {
    const newItems = [...commandeData.items];
    newItems[idx][e.target.name] = e.target.value;
    setCommandeData({ ...commandeData, items: newItems });
  };

  const addItem = () =>
    setCommandeData({
      ...commandeData,
      items: [...commandeData.items, { product: '', quantity: 1, priceAtOrder: 0 }]
    });

  const removeItem = idx => {
    const newItems = [...commandeData.items];
    newItems.splice(idx, 1);
    setCommandeData({ ...commandeData, items: newItems });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    // Calculs front‑end (optionnel, backend les refait)
    const itemsTotal = commandeData.items.reduce(
      (sum, i) => sum + i.quantity * i.priceAtOrder,
      0
    );
    const quantity = commandeData.items.reduce((sum, i) => sum + i.quantity, 0);
    const totalAmount = itemsTotal + Number(commandeData.shippingFee);

    try {
      const payload = {
        ...commandeData,
        itemsTotal,
        quantity,
        totalAmount,
      };
      const url = commandeInfo
        ? `/api/orders/${commandeInfo._id}`
        : '/api/orders';
      const method = commandeInfo ? 'put' : 'post';

      const { data } = await axios({
        method,
        url,
        data: payload,
        headers: { 'Content-Type': 'application/json' }
      });
      console.log('Commande créée/modifiée:', data);
      setOpenModal(false);
    } catch (err) {
      console.error(err);
      // gérer l’erreur (toast, message, etc.)
    } finally {
      setIsLoading(false);
    }
  };

  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center"
  });
  const { vertical, horizontal } = snackbarPosition;

  // Upload photo de profil
  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
      
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreview(e.target.result);
        setCommandeData((prev) => ({ ...prev, logo: e.target.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const toggleDrawer = (open) => (event) => {
    // On ignore certains événements clavier pour éviter des fermetures involontaires
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const mapStyle = { width: "100%", height: "400px" };
  const defaultCenter = { lat: 48.8566, lng: 2.3522 };

  // Gestion du clic sur la carte pour récupérer les coordonnées
  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setSelectedPosition({ lat, lng });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCommandeData((prev) => ({
      ...prev,

      [name]: value
    }));
  };

  const handleChangeLocalisation = (e) => {
    const { name, value } = e.target;
    // setCommandeData((prev) => ({ ...prev,

    //   [name]: value }

    // ));
    setCommandeData((prev) => ({
      ...prev,
      localisation: {
        ...prev.localisation,
        [name]: value // Mise à jour correcte des champs latitude et longitude
      }
    }));
  };

  const commandeElement = ({ element }) => {
    const url = element.siteweb && element.siteweb.startsWith("http")
      ? element.siteweb
      : `https://${element.siteweb}`;
    return (
      <div className="relative w-full h-full p-4 bg-white hover:shadow-md rounded-xl border cursor-pointer ">
        <button
          // disabled={loadingExport}
          className="absolute top-2 right-2  text-xs text-gray-600 h-7 max-w-32 px-2 font-semibold rounded-md flex items-center justify-center gap-1"
          // onClick={() => exporterListeCatechumeneInscrit(element.commande)}
        >
          <div className="dropdown dropdown-left dropdown-end">
            <div
              tabIndex={0}
              className="w-7 h-7 rounded-lg bg-gray-200 flex items-center justify-center cursor-pointer"
            >
              <img src={iconethreeDots} alt="" />
            </div>
            <ul
              tabIndex={0}
              className="dropdown-content z-50 menu p-1 shadow border bg-white rounded-lg w-32 mr-2"
            >
              <button
                onClick={() => {
                  setcommandeInfo(element);
                  openModalModif(element);
                }}
                className="w-full h-9 px-2 hover:bg-zinc-100 flex gap-x-1 items-center justify-start rounded-md"
              >
                <img src={iconePencil} alt="" className="w-5" />
                <span className="font-semibold text-sm">Modifier</span>
              </button>

              <button
                onClick={() => {
                  setcommandeInfo(element);
                  document.getElementById("delete_commande").showModal();
                }}
                className="w-full h-9 px-2 hover:bg-zinc-100 flex gap-x-1 items-center justify-start rounded-md"
              >
                <img src={iconeDelete} alt="" className="w-5" />
                <span className="font-semibold text-sm">Supprimer</span>
              </button>
            </ul>
          </div>
        </button>
        <div>
          <img src={element.logo} alt="" className="w-12 h-  " />

          <div className="w-full mt-2 ">
            <h2 className="text-black text-sm font-bold truncate ">
              {element.nom && element.nom}
            </h2>
            <p className=" text-sm  text-left font-semibold text-gray-500">
              <span className=" font-semibold">
                <span className="text-green-500 font-semibold">Ouvert</span>:{" "}
                {element.hoursOuverture ? element.hoursOuverture : "--"}{" "}
              </span>
            </p>
            <p className="mt-1 text-sm text-left font-semibold text-gray-600">
              <span className="font-semibold">
                {element.adresse ? element.adresse : "--"}
              </span>
            </p>
            <p className="mt-1 text-sm  text-left font-semibold text-gray-600">
              <span className="font-semibold">
                {element.contact ? element.contact : "--"}
              </span>
            </p>
            <p className="mt-1 hover:underline text-sm sm:text-base text-left font-semibold text-primary">
              <a href={url} target="_blank" className="font-semibold">
                {element.siteweb ? element.siteweb : "--"}
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  };

  // Fonction pour récupérer la position actuelle de l'utilisateur
  const getCurrentLocation = () => {
    setLoadingDataLocalisation(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLoadingDataLocalisation(false);
          setCurrentPosition({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        },

        (error) => {
          console.error(
            "Erreur lors de la récupération de la position :",
            error
          );
        }
      );
      //
    } else {
      setLoadingDataLocalisation(false);
      alert("La géolocalisation n'est pas supportée par votre navigateur.");
    }
  };

  const openModalModif = (element) => {
    setOpenModal(true);
    setcommandeInfo(element);
    // on récupère les données pour le formulaire
    setCommandeData({
      nom: element.nom,
      adresse: element.adresse,
      contact: element.contact,
      siteweb: element.siteweb,
      logo: element.logo,
      hoursOuverture: element.hoursOuverture,
      typecommande: element.typecommande,
      nomResponsable: element.nomResponsable,
      localisation: {
        longitude: element.localisation.longitude,
        latitude: element.localisation.latitude
      },
      jourFerie: element.jourFerie,
      facebook: element.facebook,
      instagram: element.instagram,
      whatsapp: element.whatsapp
    });
  };
  // EXPORT LISTE CATECHUMENE PAR commande
  // const exporterListeCatechumeneInscrit = (commande) => {
  //   setLoadingExport(true);
  //   exportListeCatechumene(
  //     commande.commission ? commande.commission._id : "",
  //     commande.niveau ? commande.niveau._id : "",
  //     commande._id,
  //     "VALIDER"
  //   )
  //     .then((res) => {
  //       setLoadingExport(false);
  //       const url = window.URL.createObjectURL(new Blob([res.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute(
  //         "download",
  //         `Recap-liste-catechumene-${
  //           commande ? commande.designation : "commande"
  //         }.xlsx`
  //       );
  //       document.body.appendChild(link);
  //       link.click();

  //       // Cleanup
  //       document.body.removeChild(link);
  //       window.URL.revokeObjectURL(url);
  //     })
  //     .catch((err) => {
  //       setLoadingExport(false);
  //       console.log("api error", err);
  //     });
  // };

  // === RECUPERE LISTE DES COMMISSIONS ===
  // const getListeDesCommission = () => {
  //   listeCompleteDesCommissions()
  //     .then((res) => {
  //       setListeCommission(res.data);
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //     });
  // };

  // === RECUPERE LISTE DES NIVEAUX ===
  // const getListeDesNiveauxParCommission = (commission = "") => {
  //   setListeNiveaux([]);
  //   setNiveauSelected("");
  //   listeCompleteDesNiveauParCommission(commission)
  //     .then((res) => {
  //       setListeNiveaux(res.data);
  //     })
  //     .catch((error) => {
  //       console.log("error", error);
  //     });
  // };

  const getListeDescommande = () => {
    setLoadingData(true);
    listeDesCommandes(pageQuery.page, pageQuery.size, searchParam)
      .then((res) => {
        setLoadingData(false);
        setlistecommande(res.data.Commandes);
        setCommandeData(
          {
            logo: null,
            nom: "",
            typecommande: "",
            contact: "",
            siteweb: "",
            nomResponsable: "",
            localisation: {
              longitude: null,
              latitude: null
            },
            adresse: "",
            hoursOuverture: "",
            jourFerie: "",
            facebook: "",
            instagram: "",
            whatsapp: "",
            email: "",
            password: "",
            role: "commande"
            // et les autres champs que vous avez besoin
          }
        )
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalCommandes
        }));
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error", error);
      });
  };

  const enregistrementcommande = () => {
    setIsLoading(true);

    const data = new FormData();

    // Pour chaque champ dans formData, on l'ajoute au FormData
    Object.keys(commandeData).forEach((key) => {
      if (key === "localisation") {
        data.append(key, JSON.stringify(commandeData[key]));
      } else {
        data.append(key, commandeData[key]);
      }
    });

    // console.log("data :", JSON.stringify(data));
    console.log("data :", [...data.entries()]);
    enregistrerCommandes(data)
      .then((res) => {
        setSuccessMessage("commande créé avec succès");
        getListeDescommande();
        setSnackbarOpenSuccess(true);
        setIsLoading(false);
        setOpenModal(false);
        setCommandeData({});
      })
      .catch((err) => {
        setIsLoading(false);
        if (err && err.response && err.response.data) {
          setErrorMessage(err.response.data.message);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const modifcommande = () => {
    setIsLoading(true);
    const UpdateData = {
      nom: commandeData.nom,
      adresse: commandeData.adresse,
      contact: commandeData.contact,
      siteweb: commandeData.siteweb,
      logo: commandeData.logo,
      hoursOuverture: commandeData.hoursOuverture,
      typecommande: commandeData.typecommande,
      nomResponsable: commandeData.nomResponsable,
      localisation: {
        longitude: commandeData.localisation
          ? commandeData.localisation.longitude
          : null,
        latitude: commandeData.localisation
          ? commandeData.localisation.latitude
          : null
      },
      jourFerie: commandeData.jourFerie,
      facebook: commandeData.facebook,
      instagram: commandeData.instagram,
      whatsapp: commandeData.whatsapp
    };

    // console.log("data :", [...UpdateData.entries()]);

    modifierCommandesById(commandeInfo._id, UpdateData)
      .then((res) => {
        setSuccessMessage("commande modifié avec succès");
        getListeDescommande();
        setSnackbarOpenSuccess(true);
        setIsLoading(false);
        setOpenModal(false);
        setCommandeData({});
      })
      .catch((err) => {
        setIsLoading(false);
        if (err && err.response && err.response.data) {
          setErrorMessage(err.response.data.message);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const supprimercommande = () => {
    setDeleteLoading(true);

    supprimerCommandesById(commandeInfo._id)
      .then((res) => {
        setSuccessMessage("commande supprimé avec succès");
        getListeDescommande();
        setSnackbarOpenSuccess(true);
        setDeleteLoading(false);
        document.getElementById("delete_commande").close();
      })
      .catch((err) => {
        setDeleteLoading(false);
        if (err && err.response && err.response.data) {
          setErrorMessage(err.response.data.message);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  // === FILTRER LES ELEMENTS ===
  const filterElement = () => {
    setSearchLoading(true);
    listeDesCommandes(pageQuery.page, pageQuery.size, searchParam)
      .then((res) => {
        setSearchLoading(false);
        setlistecommande(res.data.Commandes);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalCommandes
        }));
      })
      .catch((error) => {
        setSearchLoading(false);
        console.log("error", error);
      });
  };

  // === PAGINATION DES ELEMENTS ===
  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value
    }));

    listeDesCommandes(value, pageQuery.size, searchParam)
      .then((res) => {
        setLoadingData(false);
        setlistecommande(res.data.Commandes);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalCommandes
        }));
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error", error);
      });
  };

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  useEffect(() => {
    setLoadingData(true);

    listeDesCommandes(pageQuery.page, pageQuery.size, searchParam, "")
      .then((res) => {
        setLoadingData(false);
        setlistecommande(res.data.Commandes);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalCommandes
        }));
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error", error);
      });
  }, []);

  useEffect(() => {
    if (currentPosition !== null) {
      setCommandeData((prev) => ({
        ...prev,
        localisation: {
          longitude: currentPosition.lng,
          latitude: currentPosition.lat
        }
      }));
    }
  }, [currentPosition]);

  console.log("++++++, ", commandeData);

  return (
    <LayoutBackOffice>
      <div className="w-full h-full p-4">
        <div className="w-full">
          <h1 className="text-xl md:text-3xl font-extrabold">Commandes</h1>
          <p className="mt-2 text-gray-500 font-medium text-sm sm:text-base md:text-lg">
            Listes des Commandes
          </p>
        </div>

        <div className="mt-5 w-full  justify-end flex items-center gap-x-2 overflow-x-scroll sm:overflow-auto">
          <input
            type="text"
            placeholder="Rechercher un élement..."
            value={searchParam}
            onChange={(e) => setSearchParam(e.target.value)}
            className="input input-bordered w-64 sm:w-56 h-10 text-sm font-medium"
          />

          <button
            disabled={searchLoading}
            className="bg-gray-600 text-sm text-white h-10 w-fit px-4 font-semibold rounded-lg flex items-center justify-center"
            onClick={filterElement}
          >
            {!searchLoading ? (
              "Rechercher"
            ) : (
              <ThreeDots
                height="35"
                width="35"
                radius="9"
                color="#fff"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={searchLoading}
              />
            )}
          </button>
          <button
            // disabled={searchLoading}
            className="bg-primary text-sm text-white h-10 w-fit px-4 font-semibold rounded-lg flex items-center justify-center"
            onClick={() => {
              setcommandeInfo(null);
              setOpenModal(true);
            }}
          >
            Ajouter une commande
          </button>
        </div>

        {/* Liste des Commandes   */}
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 gap-2">
          {!loadingData && listecommande.length > 0 ? (
            listecommande.map((item, index) => (
              <commandeElement key={item._id} element={item} />
            ))
          ) : !loadingData && listecommande.length === 0 ? (
            <div className="w-full h-56 flex items-center justify-center">
              <p className="font-semibold text-red-600">
                Aucune commande trouvée.
              </p>
            </div>
          ) : (
            <div className="flex col-span-full w-full items-center justify-center  h-[55vh]">
              <div className="w-full  h-32 rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                <TailSpin
                  height="50"
                  width="50"
                  color="#000"
                  ariaLabel="tail-spin-loading"
                  radius="1"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={loadingData}
                />
              </div>
            </div>
          )}
        </div>

        <div className="flex justify-end mt-3">
          <Pagination
            count={pageQuery.nombrePage}
            page={pageQuery.pagePagination}
            variant="outlined"
            shape="rounded"
            onChange={handlePaginationChange}
          />
        </div>
      </div>

      {/* <Drawer
        anchor={"right"}
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <div className="w-[600px]  pt-2 px-1 flex flex-col bg-white ">
          <div className="flex justify-start ">
            <img
              onClick={() => setOpenModal(false)}
              src={iconeCloseWindow}
              className="cursor-pointer"
              alt=""
            />
          </div>

          <h2 className="mt-3 ml-2 text-lg font-extrabold">
            {commandeInfo !== null
              ? "Modifier une commande"
              : "Enregistrer une commande"}
          </h2>

          <div className="mt-10 px-2 pb-4">
            <button
              onClick={enregistrementcommande}
              className="mt-5 bg-primary flex items-center justify-center w-full h-11 font-semibold text-white rounded-lg hover:drop-shadow-md"
            >
              {!isLoading ? (
                <span>Enregistrer</span>
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={isLoading}
                />
              )}
            </button>
          </div>
        </div>
      </Drawer> */}

<Drawer
      anchor="right"
      open={openModal}
      onClose={() => setOpenModal(false)}
      className="update-commande"
    >
      <div className="w-full md:w-[400px] px-4 py-6 bg-white">
        <button
          onClick={() => setOpenModal(false)}
          className="mb-4 hover:opacity-70"
        >
          ✕ Fermer
        </button>
        <h2 className="text-xl font-bold mb-4">
          {commandeInfo ? 'Modifier une commande' : 'Nouvelle commande'}
        </h2>

        {/* Client */}
        <div className="space-y-2 mb-4">
          <h3 className="font-semibold">Client</h3>
          <input
            name="nomComplet"
            value={commandeData.client.nomComplet}
            onChange={handleClientChange}
            placeholder="Nom complet"
            className="input input-bordered w-full"
          />
          <input
            name="tel"
            value={commandeData.client.tel}
            onChange={handleClientChange}
            placeholder="Téléphone"
            className="input input-bordered w-full"
          />
        </div>

        {/* Items dynamiques */}
        <div className="space-y-2 mb-4">
          <div className="flex justify-between items-center">
            <h3 className="font-semibold">Articles</h3>
            <button onClick={addItem} className="text-primary">
              + Ajouter
            </button>
          </div>
          {commandeData.items.map((item, idx) => (
            <div key={idx} className="flex gap-2 items-end">
              <input
                name="product"
                value={item.product}
                onChange={e => handleItemChange(idx, e)}
                placeholder="ProductId"
                className="input input-bordered flex-1"
              />
              <input
                name="quantity"
                type="number"
                min="1"
                value={item.quantity}
                onChange={e => handleItemChange(idx, e)}
                placeholder="Quantité"
                className="input input-bordered w-20"
              />
              <input
                name="priceAtOrder"
                type="number"
                min="0"
                value={item.priceAtOrder}
                onChange={e => handleItemChange(idx, e)}
                placeholder="Prix"
                className="input input-bordered w-24"
              />
              <button
                onClick={() => removeItem(idx)}
                className="text-red-500"
              >
                ×
              </button>
            </div>
          ))}
        </div>

        {/* Livraison & paiement */}
        <div className="space-y-2 mb-4">
          <h3 className="font-semibold">Livraison</h3>
          <input
            name="addressLivraison"
            value={commandeData.addressLivraison}
            onChange={handleFieldChange}
            placeholder="Adresse de livraison"
            className="input input-bordered w-full"
          />
          <input
            name="city"
            value={commandeData.city}
            onChange={handleFieldChange}
            placeholder="Ville"
            className="input input-bordered w-full"
          />
          <input
            name="country"
            value={commandeData.country}
            onChange={handleFieldChange}
            placeholder="Pays"
            className="input input-bordered w-full"
          />
        </div>

        <div className="space-y-2 mb-6">
          <h3 className="font-semibold">Paiement</h3>
          <select
            name="paymentMethod"
            value={commandeData.paymentMethod}
            onChange={handleFieldChange}
            className="select select-bordered w-full"
          >
            <option value="card">Carte</option>
            <option value="paypal">PayPal</option>
            <option value="cash">Cash</option>
          </select>
          <input
            name="shippingFee"
            type="number"
            min="0"
            value={commandeData.shippingFee}
            onChange={handleFieldChange}
            placeholder="Frais de port"
            className="input input-bordered w-full"
          />
        </div>

        {/* Bouton d'envoi */}
        <button
          onClick={handleSubmit}
          disabled={isLoading}
          className="bg-primary text-white w-full py-2 rounded-lg hover:opacity-90"
        >
          {isLoading
            ? 'Envoi en cours...'
            : commandeInfo
            ? 'Modifier la commande'
            : 'Créer la commande'}
        </button>
      </div>
    </Drawer>


      {/* MODAL DELETE commande */}
      <dialog id="delete_commande" className="modal">
        <div className="modal-box rounded-lg">
          <form method="dialog">
            <button className="w-7 h-7 absolute right-2 top-2">
              <img
                onClick={() => setOpenModal(false)}
                src={iconeCloseWindow}
                className="cursor-pointer w-full"
                alt=""
              />
            </button>
          </form>
          <h3 className="font-extrabold text-xl text-center text-primary">
            Supprimer cette commande
          </h3>
          <div className="py-4">
            <p className="text-center text-base font-medium text-gray-600">
              Attention action est irrversible et entrainera la suppression de
              cette commande
            </p>
          </div>
          <div className="modal-action flex justify-center">
            <form
              method="dialog"
              className="w-full flex flex-col sm:flex-row justify-center gap-x-3"
            >
              {/* if there is a button in form, it will close the modal */}
              {deleteLoading ? (
                <div
                  disabled={deleteLoading}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </div>
              ) : (
                <button
                  disabled={deleteLoading}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </button>
              )}
              <div
                onClick={supprimercommande}
                disabled={deleteLoading}
                className="mt-2 sm:mt-0 w-full sm:w-56 px-2 h-10 bg-primary text-white text-sm rounded-lg flex items-center justify-center font-semibold cursor-pointer"
              >
                {!deleteLoading ? (
                  "Supprimer quand même"
                ) : (
                  <ThreeDots
                    height="40"
                    width="40"
                    radius="9"
                    color="#fff"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={deleteLoading}
                  />
                )}
              </div>
            </form>
          </div>
        </div>
      </dialog>

      <SwipeableDrawer
        anchor="bottom"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <div
          role="presentation"
          // Vous pouvez ajuster ces événements selon vos besoins
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
          style={{ padding: 16 }}
        >
          <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY2}>
            <Map
              style={mapStyle}
              defaultCenter={defaultCenter}
              defaultZoom={10}
              onClick={handleMapClick}
            >
              {selectedPosition && (
                <AdvancedMarker position={selectedPosition} />
              )}
            </Map>
          </APIProvider>
        </div>
      </SwipeableDrawer>

      <SnackbarAlert
        vertical={vertical}
        horizontal={horizontal}
        snackbarSuccessOpen={snackbarSuccessOpen}
        handleCloseSnackbarSuccess={handleCloseSnackbarSuccess}
        successMessage={successMessage}
        snackbarErrorOpen={snackbarErrorOpen}
        handleCloseSnackbarError={handleCloseSnackbarError}
        errorMessage={errorMessage}
      />
    </LayoutBackOffice>
  );
};

export default Commandes;
